module.exports = "https://static.energy5.com/_next/static/images/forBusiness-0cadb1e157d8516788ec5a7bd093e13b.png";